import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AlertService } from 'src/app/data-services/alert.service';
import { UserService } from 'src/app/data-services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { first } from 'rxjs/operators';
import { PostService } from 'src/app/data-services/post.service';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from 'src/app/data-services/message.service';
import {VoteQService} from 'src/app/data-services/vateQ.service';
import { HttpClient } from '@angular/common/http';
import {formatDate} from '@angular/common';
import { IffhsService } from 'src/app/data-services/iffhs.service';


@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  
  language = '';
  direction;
  defaultLanguage;
  id: number;
  userId: number;
  profile: any = {};
  currentUser: any;
  userData: any = [];
  usertype1:any;
  usertype2:any;
  usertype3:any;
  usertype4:any;
  usertype5:any;
  usertype6:any;
  usertype7:any;
  CQAll:any;
  votes:any;
  fans:any;
  posts:any;
  posts2:any;
  likestotal=0;
  commtotal=0;
  //fanscount:any;
  countries1:any;
  countryData:any;
  fanscount :any;

  user = [];

  currentDate = formatDate(Date.now(),'yyyy-MM-dd','en-US');
   constructor(
      private router: Router,
      private route: ActivatedRoute,
      private formBuilder: FormBuilder,
      private postService: PostService,
      private alertService: AlertService,
      private userService: UserService,
      private authenticationService: AuthenticationService,
      private toastrService: ToastrService,
      private messageService: MessageService,
      private VoteQService:VoteQService,
      private iffhsService: IffhsService,
      private http:HttpClient,
      public fb:FormBuilder
      ) {
      this.messageService.selectedLanguage.subscribe(res => {
        this.language = res.lang;
        this.direction = res.dir;
      });

  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.userData = JSON.parse(localStorage.getItem('userData'));

    this.getuserspresident();
    this.getusersexecutivecomm();
    this.getusersAdmin();
    this.getusersmember();
    this.getusersFans();
    this.getusersplayer();
    this.getuserslegend();
    this.lastvotingQ();
    this.getCountriesFans();
    this.Getuserpost();
    this.findsum();
    this.findsumcomm();
  }
  getuserspresident(){
    const data = {
      user_type_id: '5',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype1 = usertype);
  }
  getusersexecutivecomm(){
    const data = {
      user_type_id: '2',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype7 = usertype);
  }
  getusersAdmin(){
    const data = {
      user_type_id: '1',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype2 = usertype);
  }
  getusersmember(){
    const data = {
      user_type_id: '4',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype3 = usertype);
  }
  getusersFans(){
    const data = {
      user_type_id: '11',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype4 = usertype);
  }
  getusersplayer(){
    const data = {
      user_type_id: '13',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype5 = usertype);
  }
  getuserslegend(){
    const data = {
      user_type_id: '14',
    };
    this.userService.getcountUser(data).pipe().subscribe(usertype => this.usertype6 = usertype);
  }
  lastvotingQ(){
    const fangetdata = {
      user_id: this.currentUser.success.user.email,
    };
    this.VoteQService.getAllQA(fangetdata).pipe(first()).subscribe(
      fangetdata => {
        this.votes = fangetdata;
        for (const vote of this.votes) {
          // post.type = post.type.split('/')[0];
            //vote.VoteQ =vote.Qnumber;
            if(vote.Qstatus == 1)
            {
              const QAll = {
                VQno: vote.Qnumber,
              };
              this.VoteQService.getAllQAll(QAll).subscribe(
                QAll=>{
              this.CQAll =QAll;
              });
            }
          }
    });
  }
  getCountriesFans() {

    this.iffhsService.Getfansallcount().subscribe( Fanscount => this.fanscount = Fanscount);    
  }

  Getuserpost() {
    const data = {
      user_id: this.currentUser.success.user.id
    };
    this.postService.getNewsFeed(data).pipe(first()).subscribe( data => this.posts = data);    
  }
  findsum(){    
    const data2 = {
      user_id: this.currentUser.success.user.id
    };
    this.postService.getNewsFeed(data2).pipe(first()).subscribe( 
      data2 => {this.posts2 = data2
      for (const item of this.posts2) {
        this.likestotal += item.likesCounter;

      }
      console.log(this.likestotal);
    }); 
    }  
    findsumcomm(){    
    const data2 = {
      user_id: this.currentUser.success.user.id
    };
    this.postService.getNewsFeed(data2).pipe(first()).subscribe( 
      data2 => {this.posts2 = data2
      for (const item of this.posts2) {
        this.commtotal += item.commentsCounter;

      }
      console.log(this.commtotal);
    }); 
    }  
  
}
